import { SearchBar } from "./SearchBar";
import { ACCENT, monoFont, serifEm } from "./home-page/SectionHeading";

export function CallToAction() {
  return (
    <section
      id="get-started-today"
      className="bg-[#fafafa] px-6 pb-28 lg:px-10"
      style={{ fontFamily: "var(--font-geist)" }}
    >
      <div className="relative mx-auto max-w-6xl overflow-hidden rounded-3xl border border-neutral-200 bg-white px-6 py-24 text-center lg:py-32">
        {/* Accent glow washing up through a faint grid */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            background: `radial-gradient(ellipse 60% 70% at 50% 100%, ${ACCENT}1a, transparent 70%), linear-gradient(#0000000a 1px, transparent 1px), linear-gradient(90deg, #0000000a 1px, transparent 1px)`,
            backgroundSize: "100% 100%, 40px 40px, 40px 40px",
            maskImage:
              "radial-gradient(ellipse 70% 80% at 50% 50%, #000, transparent)",
            WebkitMaskImage:
              "radial-gradient(ellipse 70% 80% at 50% 50%, #000, transparent)",
          }}
        />

        <div className="relative">
          <h2 className="text-[clamp(40px,5.5vw,80px)] font-medium leading-[0.95] tracking-[-0.035em] text-neutral-900">
            See the magic <span style={serifEm}>in action</span>
          </h2>
          <p className="mt-6 text-[17px] text-neutral-500">
            See how Fluvo can help your business grow.
          </p>
          <div className="mt-10 flex justify-center">
            <SearchBar variant="pill" />
          </div>
          <div className="mt-3 text-[12.5px] text-neutral-400" style={monoFont}>
            Fluvo only required your website URL
          </div>
        </div>
      </div>
    </section>
  );
}
